// extracted by mini-css-extract-plugin
module.exports = {"root":"_f787e4","blackOut":"_15e71b","centered":"_1a4234","logos":"_f00b65","main":"_7c9d6f","alter":"_a76476","compareIcon":"_f76929","vs":"_c447aa"};